<template>
    <div class="core_strengths">
        <menuBox :step="2"></menuBox>
        <img src="../assets/banner-1.png" class="banner">
        <div class="text">
            Perusahaan pembiayaan otomotif memiliki keuntungan dari persetujuan cepat, metode pembayaran yang fleksibel, program pinjaman yang beragam, dan layanan pelanggan berkualitas tinggi.
            <br> Prioritas pelanggan: perusahaan selalu mengutamakan kebutuhan dan kepentingan pelanggan, dan memberikan solusi pinjaman yang dipersonalisasi untuk membantu pelanggan mewujudkan impian mobil mereka dengan lebih baik.
        </div>
        <div class="list-box">
            <div class="item-box">
                <img src="../assets/img-8.png" alt="">
                <div class="text-1">Lini produk yang luas</div>
                <div class="line-1"></div>
                <div class="text-2">Perusahaan menyediakan berbagai produk pinjaman otomotif, termasuk pinjaman pembelian mobil, pinjaman mobil bekas, dan penyewaan kendaraan, untuk memenuhi kebutuhan pelanggan yang berbeda.</div>
            </div>
            <div class="item-box">
                <img src="../assets/img-9.png" alt="">
                <div class="text-1">Layanan yang efisien dan nyaman</div>
                <div class="line-1"></div>
                <div class="text-2">Perusahaan memperhatikan pengalaman pelanggan, dan menerapkan model layanan yang nyaman seperti pinjaman online dan pengendalian risiko yang cerdas untuk mempercepat kemajuan pinjaman dan meningkatkan efisiensi.</div>
            </div>
            <div class="item-box">
                <img src="../assets/img-10.png" alt="">
                <div class="text-1">Tim profesional</div>
                <div class="line-1"></div>
                <div class="text-2">Perusahaan memiliki tim profesional dengan pengalaman yang kaya, yang dapat memberi pelanggan berbagai konsultasi dan layanan keuangan, dan memberikan perlindungan kepada pelanggan.</div>
            </div>
            <!-- <div class="item-box">
                <img src="../assets/img-11.png" alt="">
                <div class="text-1">解決方案</div>
                <div class="line-1"></div>
                <div class="text-2">幫助出海企業進軍海外市場，為出海企業提供全方位品牌出海策略，專業執行團隊打造全鏈服務，深度契合目標市場，助力企業連接世界。</div>
            </div> -->
        </div>
        <footerBox></footerBox>
    </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
    name: 'App',
    components: {
        menuBox,
        footerBox,
    },
    data() {
        return {
        }
    },
    mounted() {

    },
    methods: {

    }
}
</script>
<style lang="less" scoped>
.core_strengths{
    background: #F5F5F5;
}
.banner{
    width: 100%;
}
.text{
    font-size: 24px;
    font-weight: 500;
    color: #999999;
    padding: 120px 360px 0px 360px;
}
.list-box{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 80px 300px 120px 300px;
    .item-box{
        width: 304px;
        height: 560px;
        background: #FFFFFF;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0px 50px;
        img{
            width:80px ;
            margin-top: 67px;
        }
        .text-1{
            font-size: 24px;
            font-weight: 500;
            color: #333333;
            margin-top: 48px;
        }
        .line-1{
            width: 22px;
            height: 4px;
            background:#1C539D ;
            margin-top: 24px;
        }
        .text-2{
            margin-top: 24px;
            padding: 0px 21px;
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #999999;
        }

    }
}
</style>